import { MovementListPage } from './MovementListPage.js';

/**
 * UI_REFERENCE_SOURCE:
 * section: Sakhtar Inventory.dc.html §04 WAREHOUSE TRANSFER
 * archetype: ENTITY_LIST + create form
 * status: KIT_CONFORMANT — real create form (`POST .../inventory/transfers`,
 *   real `inventory.transfer.create` permission), each line carrying both
 *   a source and a destination warehouse+location. The board's richer
 *   4-state lifecycle (پیش‌نویس → آمادهٔ خروج → در راه → تکمیل‌شده) with a
 *   separate destination "confirm receipt" action does not exist in the
 *   real API — `postTransfer` posts the whole movement in one step, so
 *   the list only shows the real, single status the API returns (not a
 *   fabricated in-transit state).
 * state reference: ready · empty · permission_denied · network_error
 */
export function TransfersPage() {
  return (
    <MovementListPage
      endpoint="transfers"
      variant="transfer"
      title="انتقال بین انبارها"
      emptyLabel="انتقالی ثبت نشده"
      emptyDescription="انتقال جدید را از فرم بالا بین دو انبار ثبت کنید."
    />
  );
}
